import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {finalize, Observable} from "rxjs";
import {PendingRequestService} from "./pending-request.service";

/** Registers every request with the click that started it - released on answer, error and cancellation alike. */
export const pendingRequestInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const release: () => void = inject(PendingRequestService).track();
  return next(request).pipe(finalize(release));
};
